import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
    EditOutlined,
    CloseOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select, Button, Space, DatePicker, Table, Typography } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import accountService from "../../../api/account.service";
import coachService from "../../../api/coach.service";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";

const { Option } = Select;


const CoachDetailEntryComponent = (props) => {


    const handleAmountChange = (value, record, type) => {
        commonUtility.allowOnlyNumber(value);
        // console.log(record);
        props.setCoachDetailList(prevData => {
            return prevData.map(item => {
                if (item.rate_details_id === record.rate_details_id) {
                    const newData = {
                        ...item,
                        [type === 'Coach' ? 'coach_amount' : 'bta_amount']: parseFloat(commonUtility.allowOnlyNumber(value)),
                    };
                    newData.coaching_fee = newData.coach_amount + newData.bta_amount;
                    newData.isSaved = false;
                    return newData;
                }
                return item;
            });
        });
    };
    
    


    const columns = [
    //     {
    //     title: 'Id',
    //     dataIndex: 'rate_details_id',
    //     key: 'rate_details_id',
    //    },
        {
            title: 'Trainee/Member',
            dataIndex: 'rate_for',
            key: 'rate_for',
        },
        {
            title: 'Ratio',
            dataIndex: 'ratio_name',
            key: 'ratio_name',
        },
        {
            title: 'Time',
            dataIndex: 'time_tag',
            key: 'time_tag',
        },
        {
            title: 'Coach Rate',
            dataIndex: 'coach_amount',
            key: 'coach_amount',
            render: (text, record) => (
                <Input
                  style={{ width: "100px", borderRadius: "8px" }}
                  value={text}
                  onChange={(e) => handleAmountChange(e.target.value, record,'Coach')}
                />
             ),
        },
        {
            title: 'Court Amount',
            dataIndex: 'bta_amount',
            key: 'bta_amount',
            render: (text, record) => (
                <Input
                  style={{ width: "100px", borderRadius: "8px" }}
                  value={text}
                  onChange={(e) => handleAmountChange(e.target.value, record,'Court')}
                />
            ),
        },
        {
            title: 'Coaching Fees',
            dataIndex: 'coaching_fee',
            key: 'coaching_fee',
        },
        
    
        {
            title: 'Action',
            key: 'action',
            render: (text, record, index) => (
                <>
                    {
                        record.rate_details_id == 0 ? <>
                            <Button htmlType="button" type="danger" size="small" shape="round" onClick={()=>props.removeDetail(index)} > Delete <DeleteOutlined /> </Button>
                        </> : <></>
                    }
                </>
                
            )
        },
    
    
    
    
    ];

    const [ratioList, setRatioList] = useState([]);
    
    const [totalfee, setTotalFee] = useState(0);
    const [feesInputs, setFeesInputs] = useState({
        coach_amount: 0,
        bta_amount: 0
    });



    const handleChangeEvent = (e) => {
        let val = 0;
        val = e.target.value != "" && e.target.value > 0 ? e.target.value : 0;
        setFeesInputs({ ...feesInputs, [e.target.id]: parseFloat(val) });

    }


    const changeRatio = (e,v) => {
        props.coachForm.setFieldsValue({
            ratio_name: v.ratio,
        });
    }

    useEffect(() => {
        let coachAmt = 0;
        let btaAmt = 0;
        if(props.coachForm.getFieldValue("coach_amount") > 0) {
            coachAmt = parseFloat(feesInputs.coach_amount);
        }
        if(props.coachForm.getFieldValue("bta_amount") > 0) {
            btaAmt = parseFloat(feesInputs.bta_amount);
        }
        setTotalFee(coachAmt + btaAmt)
    }, [feesInputs])

    useEffect(() => {
        if(!isNaN(totalfee) && totalfee > 0){
            props.coachForm.setFieldsValue({ coaching_fee_input: parseFloat(totalfee) })
        }
        else{
            props.coachForm.setFieldsValue({coaching_fee_input:""})
        }
        
    }, [totalfee]);

    const active = (i) => {
        console.log('active',i);
    }

    








    useEffect(() => {
        coachService.ratioList().then((res) => {
            setRatioList(res.data.response_data);
        });
    }, []);




    // useEffect(()=>{
    //     setExtraaPaidAmountInfo("");
    //     props.enrollmentForm.setFieldsValue({
    //         payment_data:props.paymentPaidList
    //     });

    // },[props.paymentPaidList])

    useEffect(()=>{
        props.coachForm.setFieldsValue({
            coach_detail:props.coachDetailList,
            coaching_fee:0,
        });
       
    },[props.coachDetailList])


    return (
        <>



            <Row gutter={20}>
                <Col xs={24} xl={3}>
                    <Form.Item name="rate_for" label="Trainee/Member" >


                        <Select
                            className="text-left"
                            defaultValue="Select"
                        >

                            <Option key="SELECT" value="" >Select</Option>
                            <Option key="TRAINEE" value="TRAINEE">Trainee</Option>
                            <Option key="MEMBER" value="MEMBER">Member</Option>

                        </Select>


                    </Form.Item>


                </Col>

                <Col xs={24} xl={4}>
                    <Form.Item
                        label="Ratio"
                        name="playing_ratio_id"
                    >
                        <Select
                            className="text-left"
                            defaultValue="Select"
                            onChange={changeRatio}
                            onSelect={(event, value) => changeRatio(event,value)}
                        >

                            <Option key="" value="" >Select</Option>
                            {ratioList.length > 0
                                ? ratioList.map((ratio_list) => (
                                    <Option
                                        key={`${commonUtility.randomID()}-${ratio_list.paying_ratio_id}`}
                                        value={ratio_list.paying_ratio_id}
                                        ratio={ratio_list.ratio_name}
                                    >
                                        {ratio_list.ratio_name}
                                    </Option>
                                ))
                                : ""}
                        </Select>


                    </Form.Item>
                    <Form.Item name="ratio_name" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item name="coach_detail" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>

                    {/* <Form.Item name="selected_payment_mode_text" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>
                    
                    <Form.Item name="dr_account_id" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item name="payment_data" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item> */}

                </Col>

                <Col xs={24} xl={4}>
                    <Form.Item name="time_tag" label="Time" >
                        <Select className="text-left" defaultValue="Select">
                            <Option key="SELECT" value="" >Select</Option>
                            <Option key="DAY" value="DAY" >Day</Option>
                            <Option key="NIGHT" value="NIGHT" >Night</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} xl={3}>

                    <Form.Item name="coach_amount" label="Coach Rate"
                        rules={[
                            {
                                pattern: /^[\d]{0,9}$/,
                                message: "Only number allowed",
                            },
                        ]}
                        onChange={handleChangeEvent}
                    >
                        <Input placeholder="" />
                    </Form.Item>
                </Col>
                <Col xs={24} xl={3}>
                    <Form.Item name="bta_amount" label="Court Fee" rules={[
                            {
                                pattern: /^[\d]{0,9}$/,
                                message: "Only number allowed",
                            },
                        ]} 
                        onChange={handleChangeEvent}>
                        <Input placeholder="" />
                    </Form.Item>
                </Col>
                <Col xs={24} xl={3}>
                    <Form.Item name="coaching_fee_input" label="Coaching Fee" rules={[
                            {
                                pattern: /^[\d]{0,9}$/,
                                message: "Only number allowed",
                            },
                        ]} >
                        <Input placeholder="" readOnly={true} />
                    </Form.Item>
                </Col>
                <Col xs={24} xl={4}>
                    <Form.Item name="" label=" ">
                        <Button htmlType="button" className="custom-button-green" icon={<PlusOutlined />} onClick={props.addCoachDetail}>
                            Click to Add 
                        </Button>
                    </Form.Item>
                </Col>

            </Row>
            <Row>
                <Col xs={24} xl={24}>
                    <p className="helperText" style={{color: 'rgb(200, 92, 50)', fontWeight: 500, fontSize: '12px',fontStyle:'italic'}}>Note:  Ratio , Time, Coach Rate. , Court Fee are required</p>
                </Col>
            </Row>




            {
                props.coachDetailList.length > 0 ? <><Table rowKey={commonUtility.randomID()} size="small"columns={columns} dataSource={props.coachDetailList} pagination={false} /></> : ''
            }



        </>
    )
}

export default CoachDetailEntryComponent


